import { AppBar, Box, Container, Toolbar, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import appConfig from '../../config/app-config';
import * as PATH from '../../config/paths';
import useLayout from '../../hooks/layout/use-layout';
import { Accounting } from '../icons';
import UserMenu from './user-menu';

/** The top of the app on a phone: the name of the app and the menu of the user. */
const TopBar = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { toolbarHeight, topBarHeight, barZIndex } = useLayout();
  const basePath = appConfig.getBasePath();
  const handleTitleClick = () => {
    navigate(basePath || PATH.DASHBOARD_PATH);
  };

  return (
    <>
      {/* Top Header */}
      {/* Fixed, not sticky: on iOS a sticky bar is dragged along when the page is pulled past its top. */}
      <AppBar
        position="fixed"
        color="default"
        elevation={0}
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
          bgcolor: 'background.paper',
          top: 0,
          zIndex: barZIndex,
        }}
      >
        <Container maxWidth="lg">
          <Toolbar
            disableGutters
            sx={{
              justifyContent: 'space-between',
              minHeight: toolbarHeight,
            }}
          >
            {/* Brand/Logo */}
            <Box
              onClick={handleTitleClick}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                cursor: 'pointer',
                userSelect: 'none',
                '&:hover': { opacity: 0.8 },
              }}
            >
              <Accounting color="primary" sx={{ fontSize: 28 }} />
              <Typography
                variant="h6"
                noWrap
                sx={{
                  fontWeight: 800,
                  letterSpacing: '-0.5px',
                  color: 'text.primary',
                }}
              >
                {t('APP_NAME')}
              </Typography>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <UserMenu />
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
      {/* What the fixed bar takes, so that the page does not start under it. */}
      <Box sx={{ height: topBarHeight }} />
    </>
  );
};

export default TopBar;
